/** The booked page piece, standard look over its behavior half. */
import type { PieceInput } from '../../contract/runtime';
import type { BookedEvents } from './contract';
import { BookedView } from './BookedView';
import { useBooked } from './useBooked';

export { BookedView, useBooked };

export function Booked(props: PieceInput<BookedEvents>) {
  return <BookedView {...useBooked(props)} />;
}
